import React from "react";
import { Carousel } from "../../dynamic/Carousel/Carousel";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { getMediaDevice } from "../../helpers/index";

interface ValuesCarouselProps {
  page: number;
  itemsPerPage: any;
  items: ValuesProps[];
}

const getCorrectImage = (device: string, imageDetails: ImgDetails[]) => {
  let imgSize = "";

  switch (device) {
    case "DESKTOPXL":
    case "DESKTOP":
      imgSize = "Large";
      break;
    case "TABLET":
      imgSize = "Medium";
      break;
    case "MOBILE":
      imgSize = "Small";
      break;
  }

  let chosenImgDetails = imageDetails.filter(img => {
    return img.cropKey === imgSize;
  });

  return chosenImgDetails[0];
};

export const ValuesCarousel = (props: ValuesCarouselProps) => {
  const { page, itemsPerPage, items } = props;
  const slicedItems = items.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      className="carousel__animation-container"
    >
      {slicedItems.map(item => {
        // get image for screen size here:
        let imgDetails = getCorrectImage(getMediaDevice(), item.imageUrls);

        return (
          <div
            key={item.heading}
            className={`values-carousel__item landing-page__tile-bg ${
              item.alignment
            }${item.addGradient ? " gradient" : ""}`}
            style={{
              backgroundImage: `url("${imgDetails.imageUrl}")`
            }}
          >
            <div className="container">
              <div className="landing-page__tile-bg-text">
                <strong>{item.heading}</strong>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.mainBody
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </ReactCSSTransitionGroup>
  );
};

interface ImgDetails {
  cropKey: string;
  imageUrl: string;
}

interface ValuesProps {
  imageUrls: ImgDetails[];
  heading: string;
  mainBody: string;
  addGradient: boolean;
  alignment: string;
}

const OurValues = (props: { values: ValuesProps[] }) => {
  const { values } = props;
  const itemsToDisplay = { DESKTOPXL: 1, DESKTOP: 1, TABLET: 1, MOBILE: 1 };

  return (
    <div className="our-values">
      <Carousel
        paginateSingleItem={true}
        totalItems={values.length}
        itemsToDisplay={itemsToDisplay}
      >
        <ValuesCarousel
          page={0}
          items={values}
          itemsPerPage={itemsToDisplay["DESKTOP"]}
        />
      </Carousel>
    </div>
  );
};

export default OurValues;
